import React from "react";

export const DenyConfirm = ({ setStep, onYes, loading }) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title yellow">Deny</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>{Drupal.t("Are you sure you want to deny this bank transfer?")}</p>
      </div>
    </div>
    <div className="authorise-bank-transfer-actions step1-button gap-3 mt-4">
      <button
        type="button"
        className="secondary_btn"
        onClick={() => setStep("close")}
        disabled={loading}
      >
        {Drupal.t("No")}
      </button>
      <button
        type="button"
        className="primary_btn"
        onClick={onYes}
        disabled={loading}
      >
        {loading ? Drupal.t("Loading…") : Drupal.t("Yes")}
      </button>
    </div>
  </>
);
